import { matchTourFlightTravellerRules } from './tourFlightTravellerRules'

type Rules = NonNullable<App.Checkout.TravellerFormSchemaData['allTravellerRules']>

/** Resolve cart flight passenger IDs to the tour-labelled forms that fill their seats. */
export function mapFlightPassengersToTravellerForms(
  passengers: Array<App.Checkout.FlightPassenger>,
  travellerForms: Array<App.Checkout.TravellerForm>,
  allTravellerRules?: Rules,
): Map<string, App.Checkout.TravellerForm> {
  const formsById = new Map(travellerForms.map(form => [form.id, form]))
  if (!allTravellerRules?.length) {
    const directMatches = new Map<string, App.Checkout.TravellerForm>()
    for (const passenger of passengers) {
      const form = formsById.get(passenger.id)
      if (form) directMatches.set(passenger.id, form)
    }
    return directMatches
  }

  const assignment = matchTourFlightTravellerRules(Object.fromEntries(formsById), allTravellerRules)
  if (!assignment) return new Map()

  const availableForms = travellerForms.filter(form => assignment[form.id])
  const result = new Map<string, App.Checkout.TravellerForm>()
  for (const passenger of passengers) {
    const formIndex = availableForms.findIndex(form => assignment[form.id] === passenger.type)
    if (formIndex < 0) return new Map()
    const [form] = availableForms.splice(formIndex, 1)
    result.set(passenger.id, form)
  }
  return availableForms.length === 0 ? result : new Map()
}
